import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Wrench } from 'lucide-react';
import { Link } from 'react-router-dom';

const StickyCTABar = () => {
  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, delay: 1 }}
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden"
      style={{ pointerEvents: 'auto' }}
    >
      <div className="bg-charcoal border-t border-darkgray shadow-2xl">
        <div className="flex items-center justify-between px-4 py-3">
          {/* 🛒 SHOP NOW BUTTON */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex-1 mr-2"
          >
            <Link
              to="/shop"
              className="flex items-center justify-center gap-2 bg-brandred text-offwhite 
                         font-bold py-3 px-4 rounded-lg shadow-lg 
                         hover:bg-gradient-to-r hover:from-brandred hover:to-[#E63B3B] 
                         transition-all duration-300 w-full"
            >
              <ShoppingCart size={20} />
              Shop Now
            </Link>
          </motion.div>

          {/* 🔧 BOOK INSTALL BUTTON */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex-1 ml-2"
          >
            <Link
              to="/contact?install=true"
              className="flex items-center justify-center gap-2 bg-darkgray text-offwhite 
                         font-bold py-3 px-4 rounded-lg shadow-lg 
                         hover:bg-charcoal transition-all duration-300 w-full"
            >
              <Wrench size={20} />
              Book Install
            </Link>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default StickyCTABar;
